module.exports = __webpack_public_path__ + "media/images/covers/starworks-weekly-sept24-banner-4aa1f6ea99c5fb7d4aa0ef15f899b91b.png";